import { render } from "./SchoolSearch.vue?vue&type=template&id=0cafa3bc"
import script from "./SchoolSearch.vue?vue&type=script&lang=js"
export * from "./SchoolSearch.vue?vue&type=script&lang=js"

import "./SchoolSearch.vue?vue&type=style&index=0&id=0cafa3bc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__